import styled from 'styled-components/macro'

import { fluidSystem, ChartWrapper } from 'styled'

import { Root, OptionsRow, DonutButton, ArcPath } from './../DonutQuestion/DonutQuestion.styled'

export { Root, OptionsRow, DonutButton, ArcPath as BarPath }

export const Bar = styled(ChartWrapper)`
  ${fluidSystem};
  display: flex;
  justify-content: center;
  align-items: center;

  > .Inner {
    /* width: 100%;
    height: 100%; */
    max-height: 300px;
  }

  svg {
    width: 100%;
    height: 100%;
    overflow: visible;
  }
`

export const Label = styled.text`
  font-size: 14px;
  fill: #3c3c3c;
`
